import { roleState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SelectOption } from "components/atoms/Select";
import { config } from "config";

const initialState: roleState = {
  roles: [],
  permissions: [],
  privilege: [],
  loading: false,
  roleOptions: [],
  role: null,
  filters: {},
  current_filters: {},
  count: 0,
  refresh: 0,
  refreshLoader: false,
};

function replaceAndCapitalize(str: any) {
  var arr = str.split("_");
  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  return arr.join(" ");
}

export const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    setRoles: (state, action) => {
      state.roles = action.payload;
    },
    setPermissions: (state, action) => {

      const permissions = action.payload;
      // let options: SelectOption[] = [];

      // permissions.forEach(({ title, _id }: any) => {
      //   options.push({ value: _id, label: title });
      // });

      // state.roleOptions = options;
      state.permissions = permissions;
      state.refreshLoader = false;
    },
    setRole: (state, action) => {
      state.role = action.payload
      state.refreshLoader = false;
    },
    setPrivilege: (state, action) => {
      state.privilege = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setRoleOptions: (state, action) => {
      const roles = action.payload;
      let options: SelectOption[] = [];

      roles.forEach(({ title, _id }: any) => {

        options.push({ value: _id, label: replaceAndCapitalize(title) });
      }
      );

      state.roleOptions = options;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
      state.refreshLoader = true;
    },
    setCurrentFilters: (state, action) => {
      state.current_filters = action.payload;
    },
    resetFilters: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filters = initialState.filters;
      state.current_filters = initialState.current_filters;
    },
  },
});

export const roleReducer = roleSlice.reducer;

export const roleActions = roleSlice.actions;
